import { Evidence } from "@p0security/shared/types/evidence";
import { Typography } from "antd";

import { PermissionPreview } from "./PermissionPreview";

export const PreApprovalPreview: React.FC<{ preApproval: Evidence }> = ({
  preApproval,
}) => (
  <PermissionPreview
    requestor={
      <Typography.Text strong>{preApproval.principal}</Typography.Text>
    }
    verb="has pre-approved access to"
    permission={preApproval}
    reason={preApproval.reason}
    createdAt={preApproval.createdAt}
    approverDetail={preApproval.approver?.email}
  />
);
